import React from 'react';
import { arrayOf, number, oneOfType, shape, string } from 'prop-types';
import { Link } from 'gatsby';
import Container from 'react-bootstrap/Container';
import BreadcrumbBase from 'react-bootstrap/Breadcrumb';

const propTypes = {
  items: arrayOf(
    shape({
      id: oneOfType([string, number]).isRequired,
      uri: string,
      name: string.isRequired,
    }),
  ).isRequired,
};

const Breadcrumb = ({ items }) => {
  return (
    <Container className="c-breadcrumb">
      <BreadcrumbBase>
        <BreadcrumbBase.Item linkAs={Link} linkProps={{ to: '/' }}>
          Home
        </BreadcrumbBase.Item>
        {items.map((item) => {
          const props = {
            active: !item.uri,
            linkAs: item.uri ? Link : undefined,
            linkProps: item.uri ? { to: item.uri } : undefined,
          };

          return (
            <BreadcrumbBase.Item key={item.id} {...props}>
              {item.name}
            </BreadcrumbBase.Item>
          );
        })}
      </BreadcrumbBase>
    </Container>
  );
};

Breadcrumb.propTypes = propTypes;

export default Breadcrumb;
